<template>
  <div
    :class="navigation || culturePop ? 'popup' : '' || startProjectPop || recruitPop ? 'popup black' : '' || awardsPop ? 'black-gra' : ''"
    class="container"
  >
    <header-area />
    <div class="contact" :class="readyAction ? 'ready-action' : ''">
      <div class="contsBox">
        <div class="">
          <div class="say_hello step" v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)">
            <strong class="innerTitle mo-typo01">
              <span>Say Hello</span>
            </strong>

            <div class="conTextArea">
              <strong class="conTextTit mo-typo01">
                <span>
                  {{ contact.typo.sayHello.title[0] }}
                </span>
                <br />
                <span>
                  {{ contact.typo.sayHello.title[1] }}
                  <span class="emojiHandY">
                    <img src="@/assets/images/@ico_contact.png" alt="" />
                  </span>
                </span>
              </strong>

              <span class="conTextin">
                {{ contact.typo.sayHello.content }}
              </span>
            </div>
          </div>

          <div class="project_and_career step" v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)">
            <ul>
              <li v-for="(itm, idx) in linkList" :key="idx">
                <a href="javascript:;" @click.prevent="thisFn(itm.methode)">
                  <div class="bnrImg">
                    <img :src="imglink(itm.thumb)" alt="" />
                    <span>{{ itm.title }}</span>
                  </div>
                  <div class="bnrText">
                    <strong class="subTitle">
                      {{ itm.category }}
                    </strong>
                    <p v-html="itm.content" />
                  </div>
                  <div class="bnrArrow mo-typo01">
                    <span><img src="@/assets/images/contact_arrow.svg" alt="바로가기"/></span>
                  </div>
                </a>
              </li>
            </ul>
          </div>

          <div class="contactTops">
            <div class="web">
              <div class="contactTopText">
                <span>We’ve been</span>
                <span>expecting you.</span>
                <span>Let’s</span>
                <span>build something</span>
                <span>great together.</span>
              </div>
            </div>

            <div class="mobile">
              <div class="contactTopText">
                <span>We’ve been</span>
                <span>expecting you.</span>
                <span>Let’s</span>
                <span>build something great</span>
                <span>together.</span>
              </div>
            </div>
          </div>

          <div class="we_are_here step" v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)">
            <div class="contactImg">
              <img src="@/assets/images/@contact.jpg" alt="" />
            </div>

            <div class="hereAddress">
              <div class="addressText">
                <strong class="subTitle mo-typo01"><span>We are here</span></strong>
                <div class="addressContent">
                  <div class="adText" v-html="contact.typo.adress" />
                  <ul>
                    <li>T. +82 2 541 4642</li>
                    <li>F. +82 2 544 4106</li>
                  </ul>
                </div>
                <a
                  href="https://www.google.co.kr/maps/place/(%EC%A3%BC)%ED%94%8C%EB%A6%BD%EC%BB%A4%EB%AE%A4%EB%8B%88%EC%BC%80%EC%9D%B4%EC%85%98%EC%A6%88/@37.5183749,127.0246385,17z/data=!3m1!4b1!4m5!3m4!1s0x357ca3edab8d2da9:0xf2d99df7d17d96e!8m2!3d37.5183749!4d127.0268272?hl=ko"
                  target="_blank"
                  class="pnikLink"
                >
                  <span class="linkText">View google Map</span>
                  <span class="linkIcon">
                    <img src="@/assets/images/@pink_arrow.svg" alt="" />
                  </span>
                </a>
              </div>
            </div>
          </div>

          <div class="pulip_mail">
            <span class="heartImg">
              <img src="@/assets/images/@ico_heart.png" alt="" />
            </span>
            <div class="gradientMail">
              <a href="mailto:hi@pulip.com"> <span class="txt">hi@pulip.com</span><span class="line" /> </a>
            </div>
          </div>
        </div>
      </div>

      <router-link :to="{ name: 'main' }" class="longEnd">
        <div class="endDefault">
          <span>Main</span>
        </div>

        <div class="endTextArea">
          <div class="endText" v-html="contact.typo.footer" />
        </div>

        <div class="engBg contEndBg">
          <span />
        </div>
      </router-link>
    </div>
    <footer-area />
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import contact from "@/assets/json/contact.json";
import common from "@/shared/mixin/common.js";
export default {
  mixins: [common],
  name: "Main",
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        /* {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        }, */
        // Open Graph
        { property: "og:title", content: this.meta.title },
        /* { property: "og:description", content: this.meta.desc }, */
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        //{ property: 'og:image', content: this.pageImage },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.title }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea
  },
  data() {
    return {
      meta: {
        title: "플립커뮤니케이션즈",
        desc:
          "Together, we rise above and beyond. 우리는 사람과 IT가 더욱 가까워질 수 있도록 서로를 이어주는 연결고리가 되길 원합니다. 그렇기에 디지털 세상에 일상을 보다 멋지고 조화롭게 담아내고, 모두가 이용하기 편리하게 만들어 가는 데 집중합니다.",
        keywords:
          "웹에이전시, 디지털에이전시, 디자인에이전시, UIUX에이전시, 디자인회사, 금융권전문웹에이전시, 기업홈페이지제작업체, 기업웹사이트제작업체, 쇼핑몰제작업체, 반응형홈페이지제작업체, 모바일웹개발업체, 모바일앱개발업체, UIUX, 온라인마케팅, 온라인프로모션, 웹기획, 웹디자인, 웹개발, 웹퍼블리싱, 앱기획, 앱디자인, 앱개발, 앱퍼블리싱, 디자인가이드, 디자인시스템, 기업아이덴티티",
        url: "https://www.pulip.com"
      },
      contact,
      readyAction: false
    };
  },
  computed: {
    ...mapState("common", {
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    linkList() {
      return this.contact.link;
    }
  },
  methods: {},
  mounted() {
    this.readyAction = true;
  }
};
</script>
